(function () {
  if (window.OMBWishlist) return;

  var KEY = 'shopify_wishlist';
  var HEART_SELECTOR = '.minimal-card .wishlist-btn, .tags-card .wishlist-btn, [data-wishlist-btn]';

  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  function handleFromUrl(url) {
    var m = String(url || '').match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  // One-time move of items saved by the old wishlist page script.
  try {
    var legacy = JSON.parse(localStorage.getItem('wishlist') || 'null');
    if (Array.isArray(legacy)) {
      var merged = read();
      legacy.forEach(function (item) {
        var h = handleFromUrl(item && item.url);
        if (h && merged.indexOf(h) === -1) merged.push(h);
      });
      write(merged);
      localStorage.removeItem('wishlist');
    }
  } catch (e) {}

  function has(handle) { return read().indexOf(handle) !== -1; }

  function set(handle, on) {
    var list = read();
    var i = list.indexOf(handle);
    if (on && i === -1) list.push(handle);
    if (!on && i !== -1) list.splice(i, 1);
    write(list);
    sync();
    window.dispatchEvent(new CustomEvent('omb-wishlist:change', { detail: { handle: handle, added: on, list: list.slice() } }));
    window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list: list.slice() } }));
  }

  function toggle(handle) {
    var on = !has(handle);
    set(handle, on);
    return on;
  }

  function handleFor(btn) {
    if (btn.dataset.handle) return btn.dataset.handle;
    var card = btn.closest('.minimal-card, .tags-card');
    var link = card && card.querySelector('a[href*="/products/"]');
    if (link) return handleFromUrl(link.getAttribute('href'));
    var productInfo = btn.closest('product-info');
    if (productInfo && productInfo.dataset.url) return handleFromUrl(productInfo.dataset.url);
    return handleFromUrl(window.location.pathname);
  }

  function renderBadge(count) {
    document.querySelectorAll('a[href$="/pages/wishlist"]').forEach(function (link) {
      if (!link.closest('header, .header-wrapper, .shopify-section-group-header-group')) return;
      var badge = link.querySelector('.omb-wl-count');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'omb-wl-count';
        badge.setAttribute('aria-hidden', 'true');
        link.appendChild(badge);
      }
      badge.textContent = count > 99 ? '99+' : String(count);
      badge.hidden = !(count > 0);
      link.setAttribute('aria-label', 'Wishlist, ' + count + (count === 1 ? ' item' : ' items'));
    });
  }

  function sync() {
    var list = read();
    document.querySelectorAll(HEART_SELECTOR).forEach(function (btn) {
      var h = handleFor(btn);
      if (!h) return;
      var on = list.indexOf(h) !== -1;
      btn.classList.toggle('active', on);
      btn.classList.toggle('is-wishlisted', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
      if (btn.hasAttribute('data-wishlist-btn')) {
        var path = btn.querySelector('path');
        if (path) path.setAttribute('fill', on ? 'currentColor' : 'none');
      }
    });
    renderBadge(list.length);
  }

  // Single click handler for every heart on the site (runs before the old
  // per-card scripts, so each click toggles exactly once).
  window.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(HEART_SELECTOR);
    if (!btn) return;
    var h = handleFor(btn);
    if (!h) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var on = toggle(h);
    if (on && btn.animate) {
      btn.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }], { duration: 300 });
    }
  }, true);

  // Keep hearts right on cards loaded later (infinite scroll, filters) and in other tabs.
  var syncTimer;
  function syncSoon() { clearTimeout(syncTimer); syncTimer = setTimeout(sync, 120); }
  if ('MutationObserver' in window) {
    document.addEventListener('DOMContentLoaded', function () {
      new MutationObserver(syncSoon).observe(document.body, { childList: true, subtree: true });
    });
  }
  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) sync(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();

  window.OMBWishlist = {
    get: read,
    has: has,
    add: function (h) { set(h, true); },
    remove: function (h) { set(h, false); },
    toggle: toggle
  };
})();
